import React, { Component } from 'react';
import PaginationDot from './PaginationDot';

const styles = {
  root: {
    position: 'absolute',
    bottom: 16,
    left: 10,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10
  },
  root_mode_2: {
    position: 'absolute',
    bottom: '6px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    width: '100%'
  }
};

class Pagination extends Component {
  handleClick = (event, index) => {
    this.props.onChangeIndex(index);
  };

  render() {
    const { index, dots, mode } = this.props;

    const children = [];

    for (let i = 0; i < dots; i += 1) {
      children.push(
        <PaginationDot
          key={i}
          index={i}
          active={i === index}
          onClick={this.handleClick}
        />
      );
    }

    return (
      <div
        className={'the-pagination'}
        style={mode == 'template2' ? styles.root_mode_2 : styles.root}
      >
        {children}
      </div>
    );
  }
}

// Pagination.propTypes = {
//   dots: PropTypes.number.isRequired,
//   index: PropTypes.number.isRequired,
//   onChangeIndex: PropTypes.func.isRequired,
// };

export default Pagination;
